import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  font-size: 1.2rem;
  border: none;
  height: 4rem;
  background: none;
  font-weight: 500;
  padding: 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;

  div {
    float: left;
    flex: 1;
    display: flex;
    flex-direction: row;
    max-width: 85%;

    button {
      display: flex;
      flex: 1;
      flex-direction: row;
      overflow: hidden;
      justify-content: flex-start;
      align-items: flex-start;
      background: none;

      span {
        font-size: 1.2rem;
        color: #333;
        float: left;
        width: 100%;
        text-align: left;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      small {
        font-size: 1.2rem;
        color: #666;
      }
    }
  }

  main {
    float: left;
    display: flex;
    flex-direction: row;

    button {
      float: left;
      display: flex;
      flex-direction: row;
      margin-left: 15px;
      background: none;
    }
  }

  @media (max-width: 1024px) {
    span,
    small {
      font-size: 1rem;
      line-height: 18px;
    }
  }
`;
